import { P as POINTER_DRAG_THRESHOLD } from "./graph-W6vrFcBu.js";
function pointerEventToUserCoords(e, pointerAtDown, objectAtDownScrCoords, board) {
  const o = board.origin.scrCoords;
  const x = (objectAtDownScrCoords[1] + e.x - pointerAtDown[0] - o[1]) / board.unitX;
  const y = (o[2] - (objectAtDownScrCoords[2] + e.y - pointerAtDown[1])) / board.unitY;
  return [x, y];
}
function exceededDragThreshold(e, pointerAtDown, threshold = POINTER_DRAG_THRESHOLD) {
  const viaPointer = e.type === "pointermove";
  if (!viaPointer) {
    return true;
  }
  if (pointerAtDown === null) {
    return false;
  }
  return Math.abs(e.x - pointerAtDown[0]) > threshold || Math.abs(e.y - pointerAtDown[1]) > threshold;
}
export {
  exceededDragThreshold as e,
  pointerEventToUserCoords as p
};
